var _path, _path2, _path3, _g, _rect, _rect2, _rect3, _rect4, _rect5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeabulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 225,
    viewBox: "0 0 199 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.706 0.632812C155.482 1.31393 198.866 45.1197 198.866 99.0576L198.858 100.329C198.177 154.105 154.372 197.489 100.435 197.489L99.1621 197.481C45.8092 196.806 2.68561 153.682 2.00977 100.329L2.00195 99.0576C2.00195 44.695 46.0719 0.625 100.435 0.625L101.706 0.632812ZM100.435 1.30371C46.4468 1.30371 2.68066 45.0699 2.68066 99.0576C2.68111 153.045 46.4471 196.811 100.435 196.811C154.422 196.81 198.187 153.045 198.188 99.0576C198.188 45.0701 154.422 1.30406 100.435 1.30371ZM100.435 23.3359C142.252 23.336 176.152 57.2356 176.152 99.0527L176.146 100.031C175.622 141.398 141.925 174.77 100.435 174.771L99.4561 174.764C58.0898 174.24 24.7178 140.543 24.7178 99.0527C24.7181 57.2357 58.6175 23.3361 100.435 23.3359ZM100.435 23.8584C58.9059 23.8586 25.2406 57.5241 25.2402 99.0527C25.2402 140.582 58.9057 174.248 100.435 174.248C141.964 174.248 175.63 140.582 175.63 99.0527C175.63 57.524 141.963 23.8584 100.435 23.8584ZM101.188 40.8145C133.008 41.2177 158.679 67.1379 158.679 99.0537L158.674 99.8066C158.27 131.627 132.35 157.298 100.435 157.298L99.6816 157.293C68.1122 156.893 42.5956 131.376 42.1953 99.8066L42.1904 99.0537C42.1904 66.8865 68.2674 40.8096 100.435 40.8096L101.188 40.8145ZM100.435 41.2109C68.4892 41.211 42.5918 67.1084 42.5918 99.0537C42.5921 130.999 68.4894 156.895 100.435 156.896C132.38 156.895 158.276 130.999 158.276 99.0537C158.276 67.1084 132.38 41.211 100.435 41.2109ZM100.434 60.2275C121.878 60.2275 139.262 77.612 139.263 99.0566C139.263 120.501 121.878 137.886 100.434 137.886C78.989 137.885 61.6045 120.501 61.6045 99.0566C61.6047 77.6122 78.9892 60.2278 100.434 60.2275ZM100.434 60.4951C79.1371 60.4954 61.8723 77.7601 61.8721 99.0566C61.8721 120.353 79.1369 137.618 100.434 137.618C121.731 137.618 138.995 120.354 138.995 99.0566C138.995 77.7599 121.73 60.4951 100.434 60.4951Z",
    fill: "url(#paint0_linear_2312_2373)",
    fillOpacity: 0.22
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2312_2373",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 57,
    width: 102,
    height: 135
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.797 58.9053C85.6776 51.914 57.8918 68.743 50.7385 96.4909C46.9019 111.373 49.78 126.373 57.4457 138.16C59.9967 142.079 61.8924 144.99 63.2218 147.093C63.8953 148.157 64.549 149.233 65.1825 150.321L65.3378 150.613C66.3831 152.977 66.5888 153.561 66.667 154.07C66.7453 154.578 66.744 155.207 66.4889 157.794C66.3928 158.817 65.9738 160.496 64.794 165.073L64.7434 165.269C64.053 167.947 63.4572 170.258 63.1396 172.195C62.7999 174.244 62.6796 176.335 63.2527 178.473C63.8928 180.866 65.1364 183.03 66.8687 184.761C68.4103 186.31 70.2519 187.211 72.1624 187.899C73.9714 188.547 76.2302 189.129 78.8492 189.805L79.229 189.902C81.8479 190.578 84.1068 191.16 86.0036 191.467C88.0151 191.79 90.0512 191.882 92.1613 191.281C94.5216 190.595 96.6595 189.299 98.3599 187.524C99.8886 185.928 100.793 184.045 101.494 182.082C102.154 180.227 102.748 177.923 103.432 175.243L103.483 175.047C104.662 170.47 105.114 168.799 105.518 167.856C106.552 165.469 106.848 164.917 107.169 164.511C107.484 164.103 107.948 163.685 110.004 162.127L110.029 162.113L110.072 162.082L110.281 161.947L111.009 161.507C111.625 161.14 112.475 160.66 113.558 160.069C115.738 158.872 118.805 157.239 122.935 155.036C129.34 151.607 134.961 146.881 139.44 141.161C143.919 135.44 147.157 128.85 148.95 121.809C156.103 94.0614 139.916 65.8966 112.797 58.9053ZM92.8091 178.963C92.9843 178.483 93.1622 177.928 93.3428 177.3L72.5875 171.949C72.4418 172.586 72.3272 173.157 72.2437 173.662C72.0136 175.069 72.0883 175.619 72.1617 175.903C72.3762 176.693 72.7919 177.413 73.3681 177.995C73.5732 178.201 74.0037 178.535 75.3139 179.006C76.6813 179.498 78.5342 179.976 81.3954 180.713C84.2566 181.451 86.1095 181.929 87.5444 182.159C88.9187 182.38 89.4555 182.302 89.7366 182.214C90.522 181.984 91.2343 181.554 91.8039 180.967C92.0055 180.753 92.3368 180.308 92.8091 178.963Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.0549 129.461C79.6966 129.282 80.3673 129.231 81.0287 129.311C81.69 129.391 82.3291 129.601 82.9094 129.928C83.4897 130.255 83.9998 130.694 84.4106 131.218C84.8214 131.743 85.1248 132.343 85.3035 132.985C85.7003 134.415 86.467 135.716 87.5264 136.757C88.5857 137.797 89.9004 138.54 91.3381 138.91C92.7758 139.281 94.2857 139.266 95.7159 138.868C97.1462 138.469 98.4462 137.701 99.4852 136.641C99.9524 136.166 100.508 135.788 101.122 135.528C101.735 135.269 102.393 135.132 103.059 135.127C103.725 135.121 104.386 135.247 105.003 135.497C105.62 135.747 106.182 136.116 106.657 136.583C107.132 137.051 107.51 137.607 107.77 138.22C108.029 138.833 108.166 139.492 108.171 140.158C108.176 140.823 108.051 141.484 107.801 142.101C107.551 142.719 107.182 143.281 106.714 143.755C103.322 147.2 98.7253 149.195 93.892 149.318L91.6066 158.183C91.2709 159.485 90.4315 160.601 89.2732 161.284C88.1149 161.968 86.7325 162.163 85.4301 161.827C84.1278 161.492 83.0121 160.652 82.3286 159.494C81.6451 158.336 81.4497 156.953 81.7855 155.651L84.0709 146.786C79.8967 144.342 76.8342 140.373 75.5292 135.716C75.35 135.074 75.2991 134.404 75.3793 133.742C75.4595 133.081 75.6692 132.442 75.9965 131.861C76.3238 131.281 76.7622 130.771 77.2867 130.36C77.8111 129.949 78.4131 129.639 79.0549 129.461Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2312_2373)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2312_2373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8619 38.0837C39.5271 31.6244 46.1132 27.7381 52.5725 29.4032L186.319 63.8826C192.779 65.5478 196.665 72.1339 195 78.5932L160.52 212.34C158.855 218.799 152.269 222.686 145.81 221.02L12.063 186.541C5.60374 184.876 1.71737 178.29 3.38254 171.831L37.8619 38.0837Z",
    fill: "url(#paint1_linear_2312_2373)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8619 38.0837C39.5271 31.6244 46.1132 27.7381 52.5725 29.4032L186.319 63.8826C192.779 65.5478 196.665 72.1339 195 78.5932L160.52 212.34C158.855 218.799 152.269 222.686 145.81 221.02L12.063 186.541C5.60374 184.876 1.71737 178.29 3.38254 171.831L37.8619 38.0837Z",
    stroke: "black",
    shapeRendering: "crispEdges"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.373,
    y: 67.6133,
    width: 12.7391,
    height: 8,
    rx: 1.78628,
    transform: "rotate(23.1734 38.373 67.6133)",
    fill: "url(#paint2_linear_2312_2373)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70.2363,
    y: 38.6133,
    width: 12.7391,
    height: 8,
    rx: 1.78628,
    transform: "rotate(61.2249 70.2363 38.6133)",
    fill: "url(#paint3_linear_2312_2373)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 144.674,
    y: 62.5391,
    width: 12.7391,
    height: 8,
    rx: 1.78628,
    transform: "rotate(-50.8791 144.674 62.5391)",
    fill: "url(#paint4_linear_2312_2373)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 158.225,
    y: 87.3433,
    width: 12.7391,
    height: 8,
    rx: 1.78628,
    transform: "rotate(-21.7967 158.225 87.3433)",
    fill: "url(#paint5_linear_2312_2373)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 116.658,
    y: 38.3828,
    width: 12.7391,
    height: 8,
    rx: 1.78628,
    transform: "rotate(98.1423 116.658 38.3828)",
    fill: "url(#paint6_linear_2312_2373)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2312_2373",
    x: -27.3078,
    y: 28.5176,
    width: 252.998,
    height: 252.998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 29.8048
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.9024
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2312_2373"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2312_2373",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2312_2373",
    x1: 81.6994,
    y1: 91.3425,
    x2: 86.6585,
    y2: 187.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2312_2373",
    x1: 119.446,
    y1: 46.6429,
    x2: 76.7392,
    y2: 373.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2312_2373",
    x1: 44.7426,
    y1: 67.6133,
    x2: 46.0023,
    y2: 83.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2312_2373",
    x1: 76.6059,
    y1: 38.6133,
    x2: 77.8656,
    y2: 54.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2312_2373",
    x1: 151.043,
    y1: 62.5391,
    x2: 152.303,
    y2: 78.8312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2312_2373",
    x1: 164.594,
    y1: 87.3433,
    x2: 165.854,
    y2: 103.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2312_2373",
    x1: 123.028,
    y1: 38.3828,
    x2: 124.287,
    y2: 54.6749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeabulb);
export default __webpack_public_path__ + "static/media/ideabulb.3ab612eee452afe88917f5174ad74403.svg";
export { ForwardRef as ReactComponent };